import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

/** Helper / description text under CMS appearance controls (readable line length). */
export const CMS_APPEARANCE_HINT_CLASS =
  "max-w-prose leading-relaxed text-slate-500";

type Props = {
  children: ReactNode;
  className?: string;
  size?: "sm" | "md";
};

export function CmsAppearanceHint({ children, className, size = "md" }: Props) {
  return (
    <p
      className={cn(
        CMS_APPEARANCE_HINT_CLASS,
        size === "sm" ? "text-xs" : "text-sm",
        className,
      )}
    >
      {children}
    </p>
  );
}
